var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 114,
    viewBox: "0 0 171 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.365 0.512207V52.8517H134.696V8.7456C148.165 6.28255 160.257 3.23312 170.365 0.516289V0.512207ZM170.365 60.9438V113.283C160.252 110.566 148.167 107.517 134.696 105.054V60.9479H170.365V60.9438ZM126.555 103.675C114.999 101.865 102.585 100.588 89.63 100.361V60.9435H126.555V103.675ZM81.4956 100.361C68.5452 100.588 56.1262 101.865 44.5767 103.675V60.9438H81.4956V100.361ZM36.4423 105.057C22.9677 107.515 10.8816 110.569 0.773438 113.286V60.9466H36.4423V105.057ZM0.773438 52.8555V0.515975C10.8867 3.2329 22.9715 6.28218 36.4423 8.74528V52.8514H0.773438V52.8555ZM44.583 10.1247C56.1328 11.934 68.5531 13.2109 81.5019 13.4379V52.8558H44.583V10.1247ZM89.6363 13.4379C102.587 13.211 115.006 11.934 126.561 10.1247V52.8555H89.6363V13.4379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperations);
export default __webpack_public_path__ + "static/media/Operations.213b48305e9536548e268cfa3630413c.svg";
export { ForwardRef as ReactComponent };